import type { ID } from "../../data/BaseEntity";
import type { EmailTemplate, EmailTemplateEntry } from "../../misc/emailTemplates";
import { useCustomerContact } from "../../orders/emails/useCustomerContact";

export function useCustomerEmailTemplates(
  calculationId: ID,
  customerId: ID,
  calculationName: string,
): { isLoading: boolean; templates: EmailTemplateEntry[] } {
  const { contact, isLoading } = useCustomerContact(customerId);
  if (isLoading || !contact) {
    return { isLoading, templates: [] };
  }
  return {
    isLoading,
    templates: [
      {
        name: "Kalkulacja grupy",
        get template() {
          return new GroupCalculationTemplate([contact.email], calculationId, calculationName, contact.loginEmails);
        },
      },
    ],
  };
}

class GroupCalculationTemplate implements EmailTemplate {
  constructor(
    readonly emails: string[],
    private readonly calculationId: ID,
    private readonly calculationName: string,
    private readonly loginEmails: string[],
  ) {}

  get subject() {
    return `Kalkulacja grupy ${this.calculationName}`;
  }

  get body() {
    return `Kalkulację grupy ${this.calculationName} znajdziesz pod linkiem:

https://${window.location.host}/calculations/${this.calculationId}

Mail do logowania: ${this.loginEmails.join(", ")}`;
  }
}
